
import types from '../types';
import router from '@/router';
import { uniq } from 'lodash';

const state = {
  workPages: [],
  cachedViews: {},
  currentPage: {},
  closingPage: ''
};

const getters = {
  cachedViewsArr: state => {
    let views = [];
    Object.keys(state.cachedViews).forEach(path => {
      views = views.concat((state.cachedViews[path] || []));
    });
    return uniq(views);
  }
};

const mutations = {
  [types.WORK_PAGE_REMOVE] (state, p) {
    let index = state.workPages.findIndex(s => s.path === p);
    if (index > -1) {
      state.closingPage = state.workPages[index].path;
      state.workPages.splice(index, 1);
    }
    if(state.workPages.length === 0) {
      router.push('/variable-home');
      return;
    }
    if (p === state.currentPage.path) {
      router.back();
    }
  },
  [types.WORK_PAGE_ROUTE](state, p) {
    let index = state.workPages.findIndex(s =>
      s.routePath === p.to.routePath || (s.secondParent && (s.secondParent === p.to.secondParent))
    );
    if (index > -1) {
      if(state.workPages[index].path !== p.to.path) {
        state.workPages.splice(index, 1, p.to);
      }
      state.currentPage = state.workPages[index];
    } else {
      state.workPages.push(p.to);
      state.currentPage = p.to;
    }
    state.closingPage = '';
  },
  [types.WORK_PAGE_CLEAR_ALL] (state) {
    state.workPages = [];
    router.push('/variable-home');
  },
  [types.DEL_OTHER_WORK_PAGE] (state, view) {
    state.workPages = state.workPages.filter(w => w.path === view.path);
  },
  [types.DEL_LEFT_WORK_PAGE] (state, view) {
    const index = state.workPages.findIndex(w => w.path === view.path);
    state.workPages = state.workPages.slice(index, state.workPages.length);
    router.push({ name: view.name });
  },
  [types.DEL_RIGHT_WORK_PAGE] (state, view) {
    const index = state.workPages.findIndex(w => w.path === view.path);
    state.workPages = state.workPages.slice(0, index + 1);
    router.push({ name: view.name });
  },
  [types.REMOVE_CACHED_VIEW](state, path) {
    const { secondParent, path: currentPath } = state.workPages.find(page => page.path.includes(path) || page.secondParent === path) || {};
    if (Array.isArray(state.cachedViews[secondParent])) {
      state.cachedViews[secondParent] = [];
    }
    if (Array.isArray(state.cachedViews[currentPath])) {
      state.cachedViews[currentPath] = [];
    }
  },
  [types.ADD_CACHED_VIEW](state, p) {
    const { componentName, path: currentPath, secondParent } = p.to || {};
    if (componentName) {
      if (secondParent) {
        if (!Array.isArray(state.cachedViews[secondParent])) {
          state.cachedViews[secondParent] = [componentName];
        } else if(!state.cachedViews[secondParent].includes(componentName)){
          state.cachedViews[secondParent].push(componentName);
        }
      } else if (!Array.isArray(state.cachedViews[currentPath])) {
        state.cachedViews[currentPath] = [componentName];
      } else if (!state.cachedViews[currentPath].includes(componentName)) {
        state.cachedViews[currentPath].push(componentName);
      }
    }
    state.cachedViews = JSON.parse(JSON.stringify(state.cachedViews)); // getters无法检测到对象数组的变化
  },
  [types.DEL_OTHER_CACHED_VIEW](state, view) {
    Object.keys(state.cachedViews).forEach(path => {
      if (view.secondParent !== path && view.path !== path) {
        state.cachedViews[path] = [];
      }
    })
  },
  [types.REMOVE_ALL_CACHED_VIEW](state) {
    state.cachedViews = {};
  },
  [types.DEL_LEFT_CACHED_VIEW](state, view) {
    const index = state.workPages.findIndex(w => w.path === view.path);
    const removeComponents = state.workPages.slice(0, index);
    Object.keys(state.cachedViews).forEach(path => {
      if (removeComponents.findIndex(component => [component.secondParent, component.path].includes(path)) > -1) {
        state.cachedViews[path] = [];
      }
    })
  },
  [types.DEL_RIGHT_CACHED_VIEW](state, view) {
    const index = state.workPages.findIndex(w => w.path === view.path);
    const removeComponents = state.workPages.slice(index + 1, state.workPages.length);
    Object.keys(state.cachedViews).forEach(path => {
      if (removeComponents.findIndex(component => [component.secondParent, component.path].includes(path)) > -1) {
        state.cachedViews[path] = [];
      }
    });
  }
};

const actions = {
  workPageRemove ({ dispatch, commit }, p) {
    dispatch('removeCachedView', p).then(() => {
      commit(types.WORK_PAGE_REMOVE, p);
    })
  },
  workPageRoute ({ dispatch, commit }, p) {
    dispatch('addWorkPages', p).then(() => {
      commit(types.ADD_CACHED_VIEW, p);
    })
  },
  delOtherWorkPage ({ dispatch, commit }, view) {
    dispatch('delOtherCachedViews', view).then(() => {
      commit(types.DEL_OTHER_WORK_PAGE, view);
    })
  },
  removeAllWorkPage({ dispatch, commit }) {
    dispatch('removeAllCachedViews').then(() => {
      commit(types.WORK_PAGE_CLEAR_ALL);
    })
  },
  delLeftWorkPage({ dispatch, commit }, view) {
    dispatch('delLeftCachedViews', view).then(() => {
      commit(types.DEL_LEFT_WORK_PAGE, view);
    })
  },
  delRightWorkPage({ dispatch, commit }, view) {
    dispatch('delRightCachedViews', view).then(() => {
      commit(types.DEL_RIGHT_WORK_PAGE, view);
    })
  },
  addWorkPages({ commit }, view) {
    commit(types.WORK_PAGE_ROUTE, view);
  },
  removeCachedView({ commit }, view) {
    commit(types.REMOVE_CACHED_VIEW, view);
  },
  delOtherCachedViews({ commit }, view) {
    commit(types.DEL_OTHER_CACHED_VIEW, view);
  },
  removeAllCachedViews({ commit }) {
    commit(types.REMOVE_ALL_CACHED_VIEW);
  },
  delLeftCachedViews({ commit }, view) {
    commit(types.DEL_LEFT_CACHED_VIEW, view);
  },
  delRightCachedViews({ commit }, view) {
    commit(types.DEL_RIGHT_CACHED_VIEW, view);
   }
};

export default {
  state,
  getters,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/tab.js